import jsCookie from 'js-cookie';
import { ACTIONS, COOKIES, APPINDICATORS, ADDONS, ENVIRONMENT } from '../constants';
import createRequest from '../utils/requestService';
import getEnvVariable from '../utils/environment';
import { isPackagePro, isPackageAds } from '../utils/displayHelpers';

const sendPaymentConfirmation = (paymentMethodId, activePackage, ipCount, easeCount) => {
  let ipAddons = ipCount;
  if (!isPackagePro(activePackage)) {
    ipAddons = 0;
  }
  const body = {
    signup_session_token: jsCookie.get(COOKIES.SIGNUP_SESSION), // get from state
    package_id: activePackage,
    payment_method_id: paymentMethodId,
    additional_ip_count: ipAddons,
  };
  if (easeCount > 3) {
    body.ease_days = easeCount;
  }

  return fetch(createRequest(
    '/v3/public/s2s/signup/payment_confirmation',
    { body },
  ));
};

const createBossAccount = () => {
  const body = {
    signup_session_token: jsCookie.get(COOKIES.SIGNUP_SESSION),
    first_name: 'SendGrid',
    last_name: 'User',
  };

  return fetch(createRequest(
    '/v3/public/billing/accounts',
    { body },
  ));
};

export const getPaymentForm = history => async (dispatch, getState) => {
  dispatch({ type: APPINDICATORS.PAGE_LOADING });

  let zuoraPaymentFormParams;
  let prepopulateFields;
  try {
    const req = await fetch(`${getEnvVariable(ENVIRONMENT.MAKO_URL)}/v3/public/billing/payment_form?is_signup=1`, { method: 'GET' });
    const paymentInfo = await req.json();
    zuoraPaymentFormParams = {
      tenantId: paymentInfo.result.tenant_id,
      id: paymentInfo.result.page_id,
      token: paymentInfo.result.token,
      signature: paymentInfo.result.signature,
      key: paymentInfo.result.key,
      url: paymentInfo.result.url,
      style: 'inline',
      submitEnabled: true,
    };
    prepopulateFields = {
      field_email: getState().formInputs.email_value,
    };
  } catch (e) {
    console.error(`Something went wrong with requesting payment form: ${e}`);
    dispatch({
      type: APPINDICATORS.DISPLAY_ALERT,
      alertType: APPINDICATORS.ALERT_TYPES.DANGER,
      alertText: APPINDICATORS.ALERT_TEXT.BILLING_DOWN,
    });
    history.push('/account_details');
    dispatch({ type: APPINDICATORS.PAGE_LOADING_FINISHED });
  }

  if (zuoraPaymentFormParams && prepopulateFields) {
    dispatch({
      type: ACTIONS.GET_PAYMENT_FORM,
      formParams: zuoraPaymentFormParams,
      prepopulateFields,
      dataLoaded: true,
    });
  }

  dispatch({ type: APPINDICATORS.PAGE_LOADING_FINISHED });
};

export const zuoraCallback = (response, history) => async (dispatch, getState) => {
  const { activePackage } = getState().packages;

  let billingFailed = true;

  dispatch({ type: APPINDICATORS.PAGE_LOADING });

  if (response.success === 'false' || !response.success) {
    window.analytics.track('Zuora request failure, free account fallback');
  } else {
    try {
      // create acct in boss
      const bossReq = await createBossAccount(); // session token passed
      if (bossReq.ok && activePackage.id) {
        // confirm payment with ip count addon

        const sendPaymentConfReq = await sendPaymentConfirmation(
          response.refId,
          activePackage.id,
          getState().addOns[ADDONS.DEDICATED_IP],
          getState().addOns[ADDONS.EASE],
        );
        if (sendPaymentConfReq.ok) {
          window.analytics.track('Billing section complete');
          billingFailed = false;
          dispatch({
            type: APPINDICATORS.DISPLAY_ALERT,
            alertType: APPINDICATORS.ALERT_TYPES.SUCCESS,
            alertText: APPINDICATORS.ALERT_TEXT.USER_CREATION_SUCCESS,
          });
        }
      }
    } catch (e) {
      console.error(`Something went wrong with zuora callback requests: ${e}`);
    }
  }

  dispatch({ type: APPINDICATORS.PAGE_LOADING_FINISHED });

  if (billingFailed) {
    dispatch({
      type: APPINDICATORS.DISPLAY_ALERT,
      alertType: APPINDICATORS.ALERT_TYPES.DANGER,
      alertText: APPINDICATORS.ALERT_TEXT.BILLING_DOWN,
    });
  }

  if (isPackageAds(activePackage.id)) {
    history.push('/ads/account_details');
  } else {
    history.push('/account_details');
  }
};



// WEBPACK FOOTER //
// ./src/actions/paymentForm.js